import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { BottomSheet } from '../bottom.sheet';
let k=1,j=90;
@Component({
  selector: 'app-assign-vendor',
  templateUrl: './assign-vendor.component.html',
  styleUrls: ['./assign-vendor.component.scss'],
})
export class AssignVendorComponent {
  loader:boolean = false;
  users;
  userName;
  id;
  pageEnd:boolean=false;
  type;
  search; 
  cloneUsers;
  contactNbrMob;
  Uid;
  empty:boolean=false;
  active: boolean = false;
  dupUsers:any;
  clickId;
  category;
  cateName;
  cateId;
  clickId1;
  orgs : any=[];
  orgName;
  reqId;
  url;
  reqDetails;
  packService;
  orgId;
  catId;
  cat1Id;
  venId;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public bottomSheet: MatBottomSheet,
    public router: Router,
    public payment:PaymentService,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService) { }

    ionViewWillEnter(){
      this.url = window.location.href;
      this.reqId  = this.url.split('/').pop();
      this.id =localStorage.getItem('organizationId');  
      this.catId = sessionStorage.getItem('catId') 
      this.venId = sessionStorage.getItem('vendor')
      this.loader = true;
       this.getOrgs();
       this.getCategory();
       if (this.url.includes('packageAssign') || this.url.includes('changePackageAssign') ){
        this.service.getCustItemSubsById(this.reqId).subscribe((res:any)=>{
          this.packService =res;
        })
       } 
       if (this.url.includes('assignVendor') || this.url.includes('changeAssignVendor') ){
      this.service.getRequestById(this.reqId).subscribe((res:any)=>{
        this.reqDetails = res;
      })
    }
      }
   

     
   async  onPageScroll($event) {
      const scrollElement = await $event.target.getScrollElement();
      const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
      const currentScrollDepth = $event.detail.scrollTop;
      const targetPercent = j;
      let triggerDepth = ((scrollHeight / 100) * targetPercent);
      if (currentScrollDepth > triggerDepth) {
        if (!this.pageEnd) {
         this.getOrgs(); 
        }
        k++;
      }
    
    } 
 
    
    ionViewWillLeave(){
      this.search = undefined;
      this.search = ""
    }

  
  getOrgs() {  
    this.loader=true;  
    this.service.getOrg().subscribe((res:any)=>{
      this.orgs=res; 
      this.orgs.map(res=>{
        if(res.categories!=null){
          res.categories.map(dat=>{
            if(dat == this.catId){
              this.cat1Id = dat
              Object.assign(res,{vId:this.cat1Id})
            }
          })
        }
      }) 
      this.orgs= this.orgs.filter(res =>{return res.vId == this.catId}) 
      this.loader=false;
      })   
    }


  accept1(id) {
    this.loader = true;    
    let url = window.location.href;
    if (url.includes('assignVendor')) {
      Object.assign(this.reqDetails,{
        "vendorId": id,
        "changeAllocation":false,
        "status":9
          }) 
      this.service.confirmReq(this.reqId, this.reqDetails).subscribe(res => {
       this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['assign-employee1/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-ondemand-req']); 
        }
        // this.router.navigate(['/manage-work-assignment']);
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (url.includes('changeAssignVendor')) {
      Object.assign(this.reqDetails,{
        "vendorId": id,
        "changeAllocation":true,
        "status":9
          }) 
      this.service.confirmReq(this.reqId, this.reqDetails).subscribe(res => {
       this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['change-Alloc/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-ondemand-req']); 
        }      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (url.includes('packageAssign')) {
      Object.assign(this.packService,{
        "vendorId": id,
        "changeAllocation":false,
        "status":9
          }) 
      this.service.confirmPackReq(this.reqId, this.packService).subscribe(res => {
       this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['manageSubAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/vendor-subs']); 
        }
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (url.includes('changePackageAssign')) {
      Object.assign(this.packService,{
        "vendorId": id,
        "changeAllocation":true,
        "status":9
          }) 
      this.service.confirmPackReq(this.reqId, this.packService).subscribe(res => {
       this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['manageSubAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/vendor-subs']); 
        }
      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if(url.includes('orderAssign') || url.includes('purchaseAssign')){
      var post={
        "vendorId":id
      }
      this.service.assignOrder(this.reqId,post).subscribe((res:any)=>{
        this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(url.includes('orderAssign')){
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['orderEmpAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-Order']); 
        }
      }else{
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['purchaseEmpAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-purchase']); 
        }
      }
      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if(url.includes('vendorAssign') || url.includes('homeVendorAssign')){
      var post={
        "vendorId":id
      }
      this.service.assignOrder(this.reqId,post).subscribe((res:any)=>{
        this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(url.includes('vendorAssign')){
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['contractorAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/admin-manage-order']); 
        }
      }else{
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['homeContractorAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/vendor-manage-order']); 
        }
      }
      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if(url.includes('changeOrderAssign') || url.includes('changePurchaseAssign')){
      var post={
        "vendorId":id
      }
      this.service.changeOrderAssign(this.reqId,post).subscribe((res:any)=>{
        this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(url.includes('changeOrderAssign')){
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['orderEmpAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-Order']); 
        }
      }else{
        if(id==790){
          sessionStorage.setItem('vendor', '790')
          this.router.navigate(['purchaseEmpAssign/',+this.reqId]);
        }else{
          this.router.navigate(['/manage-purchase']); 
        }
      }
      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if(url.includes('changeVendorAssign') || url.includes('homeChangeVendorAssign')){
      var post={
        "vendorId":id
      }
      this.service.changeOrderAssign(this.reqId,post).subscribe((res:any)=>{
        this.loader = false;
        this.handler.res('Assigned Successfully !!');
        if(url.includes('changeVendorAssign')){
          if(id==790){
            sessionStorage.setItem('vendor', '790')
            this.router.navigate(['contractorAssign/',+this.reqId]);
          }else{
            this.router.navigate(['/admin-manage-order']); 
          }
        }else{
          if(id==790){
            sessionStorage.setItem('vendor', '790')
            this.router.navigate(['homeContractorAssign/',+this.reqId]);
          }else{
            this.router.navigate(['/vendor-manage-order']); 
          }
        }
      
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
  }

  select(id){
   if(this.clickId == id){
     this.clickId = "";
   }else{
     this.clickId = id
   }
  }

  select1(id){
    if(this.clickId1 == id){
      this.clickId1 = "";
    }else{
      this.clickId1 = id
    }
   }
     
   

  getCategory(){
    this.loader = true;
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category=res;
      this.loader = false;
           })
  }

  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  openBottomSheetItemCategory(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
      }
    });
  }

  cancel(){
    if(this.url.includes('packageAssign') || this.url.includes('changePackageAssign')){
      this.router.navigate(['/vendor-subs']); 
    }else if(this.url.includes('changeAssignVendor') || this.url.includes('assignVendor')  ){
      this.router.navigate(['/manage-ondemand-req']);
    }
    else if(this.url.includes('orderAssign') || this.url.includes('changeOrderAssign')){
      this.router.navigate(['/manage-Order']);
    }  else if(this.url.includes('vendorAssign') || this.url.includes('changeVendorAssign')){
      this.router.navigate(['/admin-manage-order']);
    }  else if(this.url.includes('homeVendorAssign') || this.url.includes('homeChangeVendorAssign')){
      this.router.navigate(['/vendor-manage-order']);
    }else if(this.url.includes('purchaseAssign') || this.url.includes('changePurchaseAssign')){
      this.router.navigate(['/manage-purchase ']);
    }else{
    this.router.navigate(['/vendor-request']);
  }

  }
}
